import { AccountClient, GET_CLIENTS, GET_SERVICE_ITEMS } from '@nile/graphql';

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    case 'subscriptionItemId':
      return {
        listInfo: {}
      };
    case 'clientId':
      return { listInfo: {} };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'subscriptionItemId':
      return GET_SERVICE_ITEMS;
    case 'clientId':
      return GET_CLIENTS;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'subscriptionItemId':
    case 'clientId':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  switch (field) {
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'subscriptionItemId':
      return 'getServiceItems';
    case 'clientId':
      return 'getClientList';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'subscriptionItemId':
      return options?.data?.[key].items
        .filter((el) => {
          return el?.quantityType !== 'HOURS';
        })
        .map((el) => {
          return {
            value: el.itemId,
            label: el.name,
            quantityType: el.quantityType
          };
        });
    case 'clientId':
      return options?.data?.[key].clients.map((el) => {
        return {
          value: el.accountId,
          label: el.name
        };
      });
    default:
      return options;
  }
};

const getFrequencyQuantities = () => {
  const frequencyQuantityArray = [];
  for (let i = 1; i <= 31; i++) {
    frequencyQuantityArray.push({
      label: `${i}`,
      value: `${i}`
    });
  }
  return frequencyQuantityArray;
};

export const getClientContractImportFields = [
  {
    label: 'dromo.title.clientName',
    key: 'clientId',
    type: 'select',
    selectOptions: getSelectOptions('clientId'),
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  // {
  //   label: 'dromo.title.contractName',
  //   key: 'contractName',
  //   validators: [
  //     {
  //       validate: 'required',
  //       errorMessage: 'dromo.validation.requiredField'
  //     },
  //     {
  //       validate: 'require_with',
  //       fields: [
  //         'contractStartDate',
  //         'contractEndDate',
  //         'contractDiscountRate',
  //         'subscriptionItemId',
  //         'unitPrice',
  //         'unitType',
  //         'subscriptionTerm',
  //         'applicableIn',
  //         'adjustAgainstAllItems',
  //         'adjustableItems',
  //         'carryForwardRemainingBlockHours',
  //         'autoRenew',
  //         'billDate',
  //         'effectiveFrom',
  //         'billEndDate',
  //         'remindBeforeExpiryInDays',
  //         'quantity'
  //       ],
  //       errorMessage: 'dromo.validation.requiredField'
  //     }
  //   ]
  // },
  // {
  //   label: 'dromo.title.contractStartDate',
  //   key: 'contractStartDate',
  //   // type: 'date',
  //   validators: [
  //     {
  //       validate: 'required',
  //       errorMessage: 'dromo.validation.requiredField'
  //     },
  //     {
  //       validate: 'regex_match',
  //       regex:
  //         '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
  //       errorMessage: 'dromo.validation.date'
  //     }
  //   ]
  // },
  // {
  //   label: 'dromo.title.contractEndDate',
  //   key: 'contractEndDate',
  //   // type: 'date',
  //   validators: [
  //     {
  //       validate: 'regex_match',
  //       regex:
  //         '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
  //       errorMessage: 'dromo.validation.date'
  //     }
  //   ]
  // },
  // {
  //   label: 'dromo.title.contractDiscountRate',
  //   key: 'contractDiscountRate'
  // },
  {
    label: 'dromo.title.itemName',
    key: 'subscriptionItemId',
    type: 'select',
    selectOptions: [],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.billableUnitPrice',
    key: 'unitPrice',
    type: 'number',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.unitType',
    key: 'unitType',
    type: 'select',
    selectOptions: [
      {
        label: 'admin.serviceCatalog.quantity.custom',
        value: 'CUSTOM'
      },
      {
        label: 'admin.serviceCatalog.quantity.allUsers',
        value: 'ALL_USER'
      },
      {
        label: 'admin.serviceCatalog.quantity.allAssets',
        value: 'ALL_ASSET'
      }
    ]
  },
  // {
  //   label: 'attribute.subscriptionType',
  //   key: 'subscriptionTerm',
  //   type: 'select',
  //   selectOptions: [
  //     {
  //       label: 'admin.serviceCatalog.subscriptionType.onlyOnce',
  //       value: 'ONCE'
  //     },
  //     {
  //       label: 'admin.serviceCatalog.subscriptionType.monthly',
  //       value: 'MONTHLY'
  //     },
  //     {
  //       label: 'admin.serviceCatalog.subscriptionType.annually',
  //       value: 'ANNUALLY'
  //     },
  //     {
  //       label: 'admin.serviceCatalog.subscriptionType.perpetual',
  //       value: 'PERPETUAL'
  //     }
  //   ],
  //   validators: [
  //     {
  //       validate: 'required',
  //       errorMessage: 'dromo.validation.requiredField'
  //     }
  //   ]
  // },
  {
    label: 'Frequency Type',
    key: 'frequencyType',
    type: 'select',
    selectOptions: [
      {
        label: 'Custom',
        value: 'CUSTOM'
      },
      {
        label: 'Once',
        value: 'ONCE'
      },
      {
        label: 'Perpetual',
        value: 'PERPETUAL'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  // Based on Frequency type
  {
    label: 'Frequency unit',
    key: 'frequencyUnit',
    type: 'select',
    selectOptions: [
      {
        label: 'Days',
        value: 'DAY'
      },
      {
        label: 'Weeks',
        value: 'WEEK'
      },
      {
        label: 'Months',
        value: 'MONTH'
      },
      {
        label: 'Years',
        value: 'YEAR'
      }
    ]
  },
  // Based on Frequency unit
  {
    label: 'Frequency Quantity',
    key: 'frequencyQuantity',
    type: 'select',
    selectOptions: getFrequencyQuantities()
  },
  {
    label: 'dromo.title.applicableIn',
    key: 'applicableIn',
    type: 'select',
    selectOptions: [
      {
        label: 'admin.serviceCatalog.blockHourTypes.allHours',
        value: 'ALL_HOURS'
      },
      {
        label: 'admin.serviceCatalog.blockHourTypes.businessHours',
        value: 'BUSINESS_HOURS'
      }
    ]
  },
  {
    label: 'dromo.title.adjustAgainstAllItems',
    key: 'adjustAgainstAllItems',
    type: 'select',
    selectOptions: [
      {
        label: 'app.common.true',
        value: 'true'
      },
      {
        label: 'app.common.false',
        value: 'false'
      }
    ]
  },
  {
    label: 'dromo.title.adjustableItems',
    key: 'adjustableItems'
  },
  {
    label: 'dromo.title.billDate',
    key: 'billDate',
    // type: 'date',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      },
      {
        validate: 'regex_match',
        regex:
          '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
        errorMessage: 'dromo.validation.date'
      }
    ]
  },
  {
    label: 'common.endDate',
    key: 'billEndDate',
    // type: ['date', { locale: 'en-US', displayFormat: 'YYYY-MM-DD' }],
    validators: [
      {
        validate: 'regex_match',
        regex:
          '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
        errorMessage: 'dromo.validation.date'
      }
    ]
  },
  {
    label: 'dromo.title.carryForwardRemainingBlockHrs',
    key: 'carryForwardRemainingBlockHours',
    type: 'select',
    selectOptions: [
      {
        label: 'app.common.true',
        value: 'true'
      },
      {
        label: 'app.common.false',
        value: 'false'
      }
    ]
  },
  {
    label: 'admin.serviceCatalog.autoRenew',
    key: 'autoRenew',
    type: 'select',
    selectOptions: [
      {
        label: 'app.common.true',
        value: 'true'
      },
      {
        label: 'app.common.false',
        value: 'false'
      }
    ]
  },
  {
    label: 'dromo.title.remindBeforeExpiry',
    key: 'remindBeforeExpiryInDays'
  },
  {
    label: 'dromo.title.quantityAmountHours',
    key: 'itemQuantity'
    // validators: [
    //   {
    //     validate: 'required',
    //     errorMessage: 'dromo.validation.requiredField'
    //   }
    // ]
  }
];
